import sha1 from "./sha1"
export default {
  encodeBySHA1(str){
    return sha1(str)
  }
}
